import { Box, Container } from "@chakra-ui/react";

import { Header } from "components";
import { DATA_OXFORD } from "utils/constants";

const OxfordPage = () => {
  return (
    <>
      <Header />

      <Container maxW="container.lg">
        <Box as="h1" color="grayTitle" fontSize="4xl" my="1rem">
          The Oxford 3000™
        </Box>
        <Box fontStyle="italic" as="h3" color="grayTitle" my="1rem">
          The Oxford 3000 is the list of the 3000 most important words to learn
          in English, from A1 to B2 level.
        </Box>
        <Box width="100%" height="2px" background="#333" />
        <Box display="flex" flexWrap="wrap">
          {DATA_OXFORD.map((o) => {
            return (
              <Box
                as="a"
                key={o.word}
                flex={{ base: "0 0 100%", sm: "0 0 50%", lg: "0 0 25%" }}
                my="0.5rem"
                color="grayTxt"
                cursor="pointer"
                _hover={{
                  textDecor: "underline",
                  transform: "none",
                }}
                target="_blank"
                href={`/?keyword=${o.path}`}
              >
                {o.word}
              </Box>
            );
          })}
        </Box>
      </Container>
    </>
  );
};

export default OxfordPage;
